export default {
  shop: {
    pagination: {},
    category: '',
    filter: '',
    ascending: true
  },

  cart: {
    pagination: {},
    category: '',
    filter: '',
    ascending: true
  }
}
